import { PortfolioAssetType } from 'components/features/target-achievement-support/utils/type';
import React from 'react';

export const InvestmentTrustDescription = ({
  type,
  className,
}: {
  type: PortfolioAssetType;
  className?: string;
}) => {
  return (
    <div className={`${className ? className : 'p-4'}`}>
      <div className="text-xs text-bluegray-500">
        <div>【銘柄の抽出・表示条件】</div>
        <div>
          {((): React.ReactElement => {
            switch (type) {
              case 'JP_EQ':
                return (
                  <>
                    投資対象を「国内株式」とする金融商品のうち、参考指標（国内株式）に対するβ値が0.97から1.03(※)の銘柄を抽出し、信託報酬の低い順に表示しています。
                    <br />
                    ※β値の幅について：該当銘柄が一定数存在する条件のなか、β値が1に限りなく近くなる幅に設定しています。
                  </>
                );
              case 'G_EQ':
                return (
                  <>
                    投資対象を「外国株式」とする金融商品のうち、参考指標（外国株式）に対するβ値が0.97から1.03(※)の銘柄を抽出し、信託報酬の低い順に表示しています。
                    <br />
                    ※β値の幅について：該当銘柄が一定数存在する条件のなか、β値が1に限りなく近くなる幅に設定しています。
                  </>
                );
              case 'JP_FI':
                return (
                  <>
                    投資対象を「国内債券」とする金融商品のうち、参考指標（国内債券）に対するβ値が0.97から1.03(※)の銘柄を抽出し、信託報酬の低い順に表示しています。
                    <br />
                    ※β値の幅について：該当銘柄が一定数存在する条件のなか、β値が1に限りなく近くなる幅に設定しています。
                  </>
                );
              case 'G_FI':
                return (
                  <>
                    投資対象を「外国債券」とする金融商品のうち、参考指標（外国債券）に対するβ値が0.97から1.03(※)の銘柄を抽出し、信託報酬の低い順に表示しています。「外国債券」に投資対象を限定するため通貨選択型の銘柄は除外しています。
                    <br />
                    ※β値の幅について：該当銘柄が一定数存在する条件のなか、β値が1に限りなく近くなる幅に設定しています。
                  </>
                );
              case 'REIT':
                return (
                  <>
                    投資対象を「REIT」とする金融商品のうち、参考指標（REIT）に対するβ値が0.97から1.03(※)の銘柄を抽出し、信託報酬の低い順に表示しています。「REIT」を投資対象とするもののうち、国内及び世界広域を対象地域としている金融商品に投資対象を設定するため欧州地域に投資地域が限定された銘柄は除外しています。
                    <br />
                    ※β値の幅について：該当銘柄が一定数存在する条件のなか、β値が1に限りなく近くなる幅に設定しています。
                  </>
                );
              default:
                return <></>;
            }
          })()}
        </div>
      </div>
      <div className="mt-4 text-xs text-bluegray-500">
        <div>【ご注意事項】</div>
        <div>
          アセプラに掲載されている情報は、投資判断の参考として投資一般に関する情報提供を目的とするものであり、投資の勧誘を目的とするものではありません。これらの情報に基づいて被ったいかなる損害についても、当社は一切の責任を負いません。
          投資に関するすべての決定は、利用者ご自身の判断でなさるようにお願いいたします。
          設立日が1年未満のものはリターンが表示されません。
        </div>
      </div>
    </div>
  );
};
